import css from 'styled-jsx/css';
import {
  THEME_COLOR_NAMES,
  THEME_COLOR_SHADE_NAMES,
  THEME_COLOR_TYPE_NAMES,
} from '../Theme/enums/colors';

export default function ({ getColors }) {
  return css`
    @function rem($size) {
      $remSize: calc($size / 16);
      @return #{$remSize}rem;
    }

    .price {
      display: block;
      /* modifiers alignments */
      &_align {
        &-center {
          text-align: center;
        }
        &-left {
          text-align: left;
        }
        &-right {
          text-align: right;
        }
        &-justify {
          text-align: justify;
        }
      }

      &_color {
        &-gp {
          &--${THEME_COLOR_NAMES.PRIMARY} {
            color: ${getColors(THEME_COLOR_NAMES.PRIMARY)};
          }
          &--${THEME_COLOR_NAMES.PRIMARY + '-' + THEME_COLOR_TYPE_NAMES.BLACK} {
            color: ${getColors(
              THEME_COLOR_NAMES.COMMON,
              THEME_COLOR_TYPE_NAMES.BLACK
            )};
          }
          &--black {
            color: var(--color-gp--black);
          }
          &--${THEME_COLOR_TYPE_NAMES.WHITE} {
            color: ${getColors(
              THEME_COLOR_NAMES.COMMON,
              THEME_COLOR_TYPE_NAMES.WHITE
            )};
          }
          &--${THEME_COLOR_NAMES.SECONDARY} {
            color: ${getColors(THEME_COLOR_NAMES.SECONDARY)};
          }
          &--${THEME_COLOR_NAMES.SECONDARY +
            '-' +
            THEME_COLOR_SHADE_NAMES.LIGHT} {
            color: ${getColors(
              THEME_COLOR_NAMES.SECONDARY,
              THEME_COLOR_SHADE_NAMES.LIGHT
            )};
          }
          &--${THEME_COLOR_NAMES.SECONDARY +
            '-' +
            THEME_COLOR_SHADE_NAMES.DARK} {
            color: ${getColors(
              THEME_COLOR_NAMES.SECONDARY,
              THEME_COLOR_SHADE_NAMES.DARK
            )};
          }
          &--cool-grey {
            color: var(--color-gp--cool-grey);
          }
          &--grey7 {
            color: var(--color-gp--grey7);
          }
          &--${THEME_COLOR_NAMES.GREY + '6'} {
            color: ${getColors(THEME_COLOR_NAMES.GREY, '6')};
          }
          &--${THEME_COLOR_NAMES.GREY + '5'} {
            color: ${getColors(THEME_COLOR_NAMES.GREY, '5')};
          }
          &--grey5b {
            color: var(--color-gp--grey5b);
          }
          &--${THEME_COLOR_NAMES.GREY + '4'} {
            color: ${getColors(THEME_COLOR_NAMES.GREY, '4')};
          }
          &--grey4a {
            color: var(--color-gp--grey4a);
          }
          &--${THEME_COLOR_NAMES.GREY + '3'} {
            color: ${getColors(THEME_COLOR_NAMES.GREY, '3')};
          }
          &--${THEME_COLOR_NAMES.GREY + '2'} {
            color: ${getColors(THEME_COLOR_NAMES.GREY, '2')};
          }
          &--${THEME_COLOR_NAMES.GREY + '1'} {
            color: ${getColors(THEME_COLOR_NAMES.GREY, '1')};
          }
          &--grey1a {
            color: var(--color-gp--grey1a);
          }
          &--greya {
            color: var(--color-gp--greya);
          }
          &--grey0 {
            color: var(--color-gp--grey0);
          }
          &--${THEME_COLOR_NAMES.ORANGE} {
            color: ${getColors(THEME_COLOR_NAMES.ORANGE)};
          }
          &--${THEME_COLOR_NAMES.ORANGE + '-' + THEME_COLOR_SHADE_NAMES.LIGHT} {
            color: ${getColors(
              THEME_COLOR_NAMES.ORANGE,
              THEME_COLOR_SHADE_NAMES.LIGHT
            )};
          }
          &--${THEME_COLOR_NAMES.ORANGE + '-' + THEME_COLOR_SHADE_NAMES.DARK} {
            color: ${getColors(
              THEME_COLOR_NAMES.ORANGE,
              THEME_COLOR_SHADE_NAMES.DARK
            )};
          }
          &--${THEME_COLOR_NAMES.YELLOW} {
            color: ${getColors(THEME_COLOR_NAMES.YELLOW)};
          }
          &--${THEME_COLOR_NAMES.YELLOW + '-' + THEME_COLOR_SHADE_NAMES.LIGHT} {
            color: ${getColors(
              THEME_COLOR_NAMES.YELLOW,
              THEME_COLOR_SHADE_NAMES.LIGHT
            )};
          }
          &--${THEME_COLOR_NAMES.YELLOW + '-' + THEME_COLOR_SHADE_NAMES.DARK} {
            color: ${getColors(
              THEME_COLOR_NAMES.YELLOW,
              THEME_COLOR_SHADE_NAMES.DARK
            )};
          }
          &--blue-a {
            color: var(--color-gp--blue-a);
          }
          &--blue-dark {
            color: var(--color-gp--blue-dark);
          }
          &--${THEME_COLOR_NAMES.PURPLE} {
            color: ${getColors(THEME_COLOR_NAMES.PURPLE)};
          }
          &--${THEME_COLOR_NAMES.PURPLE + '-' + THEME_COLOR_SHADE_NAMES.LIGHT} {
            color: ${getColors(
              THEME_COLOR_NAMES.PURPLE,
              THEME_COLOR_SHADE_NAMES.LIGHT
            )};
          }
          &--${THEME_COLOR_NAMES.PURPLE + '-' + THEME_COLOR_SHADE_NAMES.DARK} {
            color: ${getColors(
              THEME_COLOR_NAMES.PURPLE,
              THEME_COLOR_SHADE_NAMES.DARK
            )};
          }
          &--${THEME_COLOR_NAMES.MAGENTA} {
            color: ${getColors(THEME_COLOR_NAMES.MAGENTA)};
          }
          &--${THEME_COLOR_NAMES.MAGENTA +
            '-' +
            THEME_COLOR_SHADE_NAMES.LIGHT} {
            color: ${getColors(
              THEME_COLOR_NAMES.MAGENTA,
              THEME_COLOR_SHADE_NAMES.LIGHT
            )};
          }
          &--${THEME_COLOR_NAMES.MAGENTA + '-' + THEME_COLOR_SHADE_NAMES.DARK} {
            color: ${getColors(
              THEME_COLOR_NAMES.MAGENTA,
              THEME_COLOR_SHADE_NAMES.DARK
            )};
          }
          &--pipper {
            color: var(--color-gp--pipper);
          }
          &--pipper-light {
            color: var(--color-gp--pipper-light);
          }
          &--pipper-dark {
            color: var(--color-gp--pipper-dark);
          }
          &--red {
            color: var(--color-gp--red);
          }
          &--red-light {
            color: var(--color-gp--red-light);
          }
          &--red-dark {
            color: var(--color-gp--red-dark);
          }
          &--orchid-dark {
            color: var(--color-gp--orchid-dark);
          }
          &--blue { color: var(--color-movistar--blue);  }
          &--dark-blue { color: var(--color-movistar--Dark-blue);  }
          &--blue-10 { color: var(--color-movistar--blue10);  }
          &--blue-30 { color: var(--color-movistar--blue30);  }
          &--blue-55 { color: var(--color-movistar--blue55);  }
          &--white { color: var(--color-movistar--white);  }
          &--green { color: var(--color-movistar--green);  }
          &--green-10 { color: var(--color-movistar--green10);  }
          &--green-70 { color: var(--color-movistar--green70);  }
          &--grey-6 { color: var(--color-movistar--grey6);  }
          &--grey-5 { color: var(--color-movistar--grey5);  }
          &--grey-4 { color: var(--color-movistar--grey4);  }
          &--grey-3 { color: var(--color-movistar--grey3);  }
          &--grey-2 { color: var(--color-movistar--grey2);  }
          &--grey-1 { color: var(--color-movistar--grey1);  }
          &--orange { color: var(--color-movistar--orange);  }
          &--orange-10 { color: var(--color-movistar--orange10);  }
          &--orange-80 { color: var(--color-movistar--orange80);  }
          &--purple { color: var(--color-movistar--purple);  }
          &--purple-10 { color: var(--color-movistar--purple10);  }
          &--purple-70 { color: var(--color-movistar--purple70);  }
          &--red { color: var(--color-movistar--red);  }
          &--red-10 { color: var(--color-movistar--red10);  }
          &--red-55 { color: var(--color-movistar--red55);  }
          &--red-70 { color: var(--color-movistar--red70);  }  
        }

        &-emp {
          &--blue,//////////
          &--${THEME_COLOR_NAMES.PRIMARY} {
            color: ${getColors(THEME_COLOR_NAMES.PRIMARY)};
          }
          &--blue-light {
            color: var(--color-emp--blue-light);
          }
          &--light-blue {
            color: var(--color-emp--light-blue);
          }
          &--blue-medium {
            color: var(--color-emp--blue-medium);
          }
          &--medium-blue {
            color: var(--color-emp--medium-blue);
          }
          &--blue-dark {
            color: var(--color-emp--blue-dark);
          }
          &--dark-blue {
            color: var(--color-emp--dark-blue);
          }
          &--cool-grey {
            color: var(--color-emp--cool-grey);
          }
          &--green, //////////
          &--${THEME_COLOR_NAMES.SECONDARY} {
            color: ${getColors(THEME_COLOR_NAMES.SECONDARY)};
          }
          &--${THEME_COLOR_NAMES.SECONDARY +
            '-' +
            THEME_COLOR_SHADE_NAMES.DARK} {
            color: ${getColors(
              THEME_COLOR_NAMES.SECONDARY,
              THEME_COLOR_SHADE_NAMES.DARK
            )};
          }
          &--dark-green {
            color: var(--color-emp--dark-green);
          }
          &--green-medium {
            color: var(--color-emp--green-medium);
          }
          &--medium-green {
            color: var(--color-emp--medium-green);
          }
          &--${THEME_COLOR_NAMES.SECONDARY +
            '-' +
            THEME_COLOR_SHADE_NAMES.LIGHT} {
            color: ${getColors(
              THEME_COLOR_NAMES.SECONDARY,
              THEME_COLOR_SHADE_NAMES.LIGHT
            )};
          }
          &--light-green {
            color: var(--color-emp--light-green);
          }
          &--${THEME_COLOR_NAMES.GREY + '1'} {
            color: ${getColors(THEME_COLOR_NAMES.GREY, '1')};
          }
          &--${THEME_COLOR_NAMES.GREY + '2'} {
            color: ${getColors(THEME_COLOR_NAMES.GREY, '2')};
          }
          &--${THEME_COLOR_NAMES.GREY + '3'} {
            color: ${getColors(THEME_COLOR_NAMES.GREY, '3')};
          }
          &--${THEME_COLOR_NAMES.GREY + '4'} {
            color: ${getColors(THEME_COLOR_NAMES.GREY, '4')};
          }
          &--${THEME_COLOR_NAMES.GREY + '5'} {
            color: ${getColors(THEME_COLOR_NAMES.GREY, '5')};
          }
          &--${THEME_COLOR_NAMES.GREY + '6'} {
            color: ${getColors(THEME_COLOR_NAMES.GREY, '6')};
          }
          &--grey7 {
            color: var(--color-emp--grey7);
          }
          &--grey8 {
            color: var(--color-emp--grey8);
          }
          &--grey9 {
            color: var(--color-emp--grey9);
          }
          &--${THEME_COLOR_NAMES.ORANGE + '-' + THEME_COLOR_SHADE_NAMES.DARK} {
            color: ${getColors(
              THEME_COLOR_NAMES.ORANGE,
              THEME_COLOR_SHADE_NAMES.DARK
            )};
          }
          &--dark-orange {
            color: var(--color-emp--dark-orange);
          }
          &--orange-medium {
            color: var(--color-emp--orange-medium);
          }
          &--medium-orange {
            color: var(--color-emp--medium-orange);
          }
          &--${THEME_COLOR_NAMES.ORANGE + '-' + THEME_COLOR_SHADE_NAMES.LIGHT} {
            color: ${getColors(
              THEME_COLOR_NAMES.ORANGE,
              THEME_COLOR_SHADE_NAMES.LIGHT
            )};
          }
          &--light-orange {
            color: var(--color-emp--light-orange);
          }
          &--${THEME_COLOR_NAMES.PURPLE} {
            color: ${getColors(THEME_COLOR_NAMES.PURPLE)};
          }
          &--${THEME_COLOR_NAMES.PURPLE + '-' + THEME_COLOR_SHADE_NAMES.DARK} {
            color: ${getColors(
              THEME_COLOR_NAMES.PURPLE,
              THEME_COLOR_SHADE_NAMES.DARK
            )};
          }
          &--dark-purple {
            color: var(--color-emp--dark-purple);
          }
          &--medium-purple {
            color: var(--color-emp--medium-purple);
          }
          &--${THEME_COLOR_NAMES.PURPLE + '-' + THEME_COLOR_SHADE_NAMES.LIGHT} {
            color: ${getColors(
              THEME_COLOR_NAMES.PURPLE,
              THEME_COLOR_SHADE_NAMES.LIGHT
            )};
          }
          &--light-purple {
            color: var(--color-emp--light-purple);
          }
          &--red {
            color: var(--color-emp--red);
          }
          &--yellow {
            color: var(--color-emp--yellow);
          }
          &--yellow-dark {
            color: var(--color-emp--purple-dark);
          }
          &--dark-yellow {
            color: var(--color-emp--dark-yellow);
          }
          &--yellow-light {
            color: var(--color-emp--yellow-light);
          }
          &--light-yellow {
            color: var(--color-emp--light-yellow);
          }
          &--medium-yellow {
            color: var(--color-emp--medium-yellow);
          }
          &--black {
            color: var(--color-emp--black);
          }
          &--${THEME_COLOR_TYPE_NAMES.WHITE} {
            color: ${getColors(
              THEME_COLOR_NAMES.COMMON,
              THEME_COLOR_TYPE_NAMES.WHITE
            )};
          }
          &--coral {
            color: var(--color-emp--coral);
          }
          &--coral-light {
            color: var(--color-emp--coral-light);
          }
          &--coral-dark {
            color: var(--color-emp--coral-dark);
          }
          &--orchid-dark {
            color: var(--color-emp--orchid-dark);
          }
        }
      }

      &_decoration {
        &--linethrough {
          text-decoration: line-through;
        }
        &--underline {
          text-decoration: underline;
        }
      }

      &_size {
        &--regular {
          font-size: rem(24);
        }
        &--small {
          font-size: rem(16);
        }
        &--emp-40 {
          font-size: rem(40);
        }
        &--emp-30 {
          font-size: rem(30);
        }
        &--emp-24 {
          font-size: rem(24);
        }
        &--emp-28 {
          font-size: rem(28);
        }
        &--emp-22 {
          font-size: rem(22);
        }
        &--emp-18 {
          font-size: rem(18);
        }
        &--emp-16 {
          font-size: rem(16);
        }
        /* TEXT PRESETS */
        &--tp10 { font-size: var(--tp10-desktop-size); line-height: var(--tp10-desktop-line-height);}
        &--tp9 { font-size: var(--tp9-desktop-size); line-height: var(--tp9-desktop-line-height);}
        &--tp8 { font-size: var(--tp8-desktop-size); line-height: var(--tp8-desktop-line-height);}
        &--tp7 { font-size: var(--tp7-desktop-size); line-height: var(--tp7-desktop-line-height); }
        &--tp6 { font-size: var(--tp6-desktop-size); line-height: var(--tp6-desktop-line-height); }
        &--tp5 { font-size: var(--tp5-desktop-size); line-height: var(--tp5-desktop-line-height); }
        &--tp4 { font-size: var(--tp4-desktop-size); line-height: var(--tp4-desktop-line-height); }
        &--tp3 { font-size: var(--tp3-desktop-size); line-height: var(--tp3-desktop-line-height); }
        &--tp2 { font-size: var(--tp2-desktop-size); line-height: var(--tp2-desktop-line-height);}
        &--tp1 { font-size: var(--tp1-desktop-size); line-height: var(--tp1-desktop-line-height);}
        &--tp0 { font-size: var(--tp0-desktop-size); line-height: var(--tp0-desktop-line-height);}
      }

      &_opacity {
        &--op-1 {
          opacity: 1;
        }
        &--op-0-5 {
          opacity: 0.5;
        }
        &--op-0-25 {
          opacity: 0.25;
        }
      }

      &_gp {
        &--font{
          &-regular {
            font-family: var(--regular-font);
            font-weight: 400;
          }
          &-light {
            font-family: var(--light-font);
            font-weight: 300;
          }
          &-bold {
            font-family: var(--bold-font);
            font-weight: 700;
          }
          &-thin {
            font-family: var(--light-font);
            font-weight: 200;
          }
          &-hand {
            font-family: var(--hand-font);
          }
        }
      }

      &_emp {
        &--font-regular {
          font-family: var(--regular-font-emp);
          font-weight: 400;
        }
        &--font-light {
          font-family: var(--light-font-emp);
          font-weight: 300;
        }
        &--font-bold {
          font-family: var(--bold-font-emp);
          font-weight: 700;
        }
        &--font-thin {
          font-family: var(--thin-font-emp);
          font-weight: 200;
        }
        &--font-hand {
          font-family: var(--hand-font-emp);
        }
      }
    }
    @media screen and (max-width:1223px) {
      .price { 
        /* FONTS */
        &_size {
          /* TEXT PRESETS */
          &--tp10 { font-size: var(--tp10-mobile-size); line-height: var(--tp10-mobile-line-height);}
          &--tp9 { font-size: var(--tp9-mobile-size); line-height: var(--tp9-mobile-line-height);}
          &--tp8 { font-size: var(--tp8-mobile-size); line-height: var(--tp8-mobile-line-height);}
          &--tp7 { font-size: var(--tp7-mobile-size); line-height: var(--tp7-mobile-line-height); }
          &--tp6 { font-size: var(--tp6-mobile-size); line-height: var(--tp6-mobile-line-height); }
          &--tp5 { font-size: var(--tp5-mobile-size); line-height: var(--tp5-mobile-line-height); }
          &--tp4 { font-size: var(--tp4-mobile-size); line-height: var(--tp4-mobile-line-height); }
          &--tp3 { font-size: var(--tp3-mobile-size); line-height: var(--tp3-mobile-line-height); }
          &--tp2 { font-size: var(--tp2-mobile-size); line-height: var(--tp2-mobile-line-height);}
          &--tp1 { font-size: var(--tp1-mobile-size); line-height: var(--tp1-mobile-line-height);}
          &--tp0 { font-size: var(--tp0-mobile-size); line-height: var(--tp0-mobile-line-height);}
        }
      }
    }
  `;
}
